export const getFormattedHours = (milliseconds: number): string => {
  const hoursLeft = Math.floor(milliseconds / 1000 / 60 / 60);
  return formatTimeValue(hoursLeft);
};

export const getFormattedMinutes = (milliseconds: number): string => {
  const minutes = Math.floor(milliseconds / 1000 / 60);
  const hoursLeft = Math.floor(milliseconds / 1000 / 60 / 60);
  const minutesLeft = minutes - hoursLeft * 60;
  return formatTimeValue(minutesLeft);
};

export const getFormattedSeconds = (milliseconds: number): string => {
  const seconds = Math.floor(milliseconds / 1000);
  const minutesLeft = Math.floor(seconds / 60);
  const secondsLeft = seconds - minutesLeft * 60;
  return formatTimeValue(secondsLeft);
};

const formatTimeValue = (timeValue: number): string => {
  if (timeValue < 10) {
    return `0${timeValue}`;
  }
  return `${timeValue}`;
};

export const getTimeAgo = (milliseconds: number): string => {
  const timeDiff = new Date().getTime() - milliseconds;
  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  if (timeDiff < minute) {
    return '<1min ago';
  }
  if (timeDiff < hour) {
    return `${Math.floor(timeDiff / minute)}min ago`;
  }
  if (timeDiff < day) {
    return `${Math.floor(timeDiff / hour)}h ago`;
  }
  return `${Math.floor(timeDiff / day)}d ago`;
};

export const formatTaskDuration = (runtime: number): string => {
  const hours = Math.floor(runtime);
  const minutesLeft = (runtime - hours) * 60;
  let minutes = Math.floor(minutesLeft);
  const secondsLeft = (minutesLeft - minutes) * 60;
  const seconds = Math.floor(secondsLeft);
  if (seconds > 0) {
    minutes += 1;
  }
  let timeString = '';

  if (hours > 0) {
    timeString = `${hours} hr`;
    if (minutes > 0) {
      timeString += ` ${minutes} min`;
    }
  } else {
    if (minutes > 0) {
      timeString = `${minutes} min`;
    } else {
      timeString = `0 min`;
    }
  }

  return timeString;
};
